/**
 * Determines if the given variable is an object.
 *
 * @param {} obj Any piece of data
 * @return {boolean} Whether or not the given variable is an object
 */
function isObject(obj) {
  return obj !== null && typeof obj === 'object';
}

/**
 * Replace any variables in the text with the data from the context.
 *
 * @param {string} text The text to modify
 * @param {Object} context The context to look for variables
 * @return {string}
 */
export function interpolateText(text, context) {
  const textContext = isObject(context) ? context : {};

  return text.replace(/\{\s*(\w+)\s*\}/g, (_, variable) => {
    if (Object.prototype.hasOwnProperty.call(textContext, variable)) {
      return textContext[variable];
    }
    return '';
  });
}


/**
 * A CMS Text object
 * @typedef {Object} CMSTextObject
 * @property {string} key - The marketplace text key.
 * @property {string} value - The marketplace text value.
 * @property {boolean} enabled - Indicates if the marketplace text is enabled.
 */

/**
 * Get the value from a CMS text object and default to ''
 *
 * @param cmsTextObject
 * @param {string} defaultValue - The default value to return if the text is not found
 * @param categoryId
 * @return {string} The value of the CMSText object or defaultValue
 */
export function getValueFromCMSTextObject(cmsTextObject, defaultValue = '', categoryId = 'default') {
  if (cmsTextObject[categoryId] && cmsTextObject[categoryId].enabled) {
    return cmsTextObject[categoryId].value;
  } else if (cmsTextObject.default && cmsTextObject.default.enabled) {
    return cmsTextObject.default.value;
  }

  return defaultValue;
}

/**
 * Retrieve a property from a nested object
 *
 * @param {Object} obj - An object that's nested an arbitrary amount
 * @param {string[]} keyArray - An array of properties to follow
 * @return {CMSTextObject} The CMSText object to be retrieved
 */
export function retrieveCMSTextFromDeepObject(obj, keyArray) {
  if (!isObject(obj)) {
    return {};
  }
  let baseObject = obj;
  for (let i = 0; i < keyArray.length; i += 1) {
    baseObject = baseObject[keyArray[i]];
    if (!isObject(baseObject)) {
      return {};
    }
  }
  return baseObject;
}
